/*
 * MER conversion tracking
 * Fires events to GA4 (gtag) and Meta Pixel (fbq) for design funnel actions.
 * Loaded sitewide via theme.liquid.
 */
(function () {
  'use strict';

  function fireGA(name, params) {
    if (typeof gtag === 'function') {
      gtag('event', name, params || {});
    }
  }

  function fireMeta(name, params) {
    if (typeof fbq === 'function') {
      fbq('track', name, params || {});
    }
  }

  function fireBoth(gaName, metaName, params) {
    fireGA(gaName, params);
    fireMeta(metaName, params);
  }

  // Funnel page views — fires on landing
  function onReady() {
    var path = window.location.pathname;

    // 1. Ring builder page visited (the new builder — old one was deprecated, new one still active)
    if (path.indexOf('/pages/custom-design-engagement-ring') === 0) {
      fireBoth('builder_started', 'InitiateCheckout', {
        content_category: 'ring-builder',
        content_name: 'pencilshop-builder'
      });
    }

    // 2. AI design form page visited
    if (path.indexOf('/pages/custom-design-form-new') === 0) {
      fireBoth('ai_design_viewed', 'ViewContent', {
        content_category: 'ai-design-tool',
        content_name: 'wishtype-ai-form'
      });
    }

    // 3. Appointment / consult landing page visited
    if (path.indexOf('/pages/showroom-appointment') === 0 ||
        path.indexOf('/pages/appointmentpage') === 0) {
      fireBoth('appointment_page_viewed', 'ViewContent', {
        content_category: 'appointment',
        content_name: 'showroom-appointment'
      });
    }

    bindFormSubmits();
    bindConsultClicks();
    bindChatOpens();
  }

  // 4. Quote form submission tracking
  function bindFormSubmits() {
    var quoteForm = document.querySelector('#custom-quote, form[action*="quote"], .mer-quote-form form');
    if (quoteForm) {
      quoteForm.addEventListener('submit', function () {
        fireBoth('quote_submitted', 'Lead', {
          content_category: 'quote-form',
          value: 0,
          currency: 'AUD'
        });
      });
    }

    // AI form via Wishtype: listen for postMessage from the iframe
    window.addEventListener('message', function (event) {
      if (!event || !event.data) return;
      var data = event.data;
      var type = (typeof data === 'string') ? data : (data.type || data.event || '');

      if (typeof type === 'string') {
        if (type.indexOf('wishtype_submit') > -1 || type.indexOf('design_submitted') > -1) {
          fireBoth('ai_design_submitted', 'Lead', {
            content_category: 'ai-design-tool',
            value: 0,
            currency: 'AUD'
          });
        }

        // PencilShop builder completion (still active — old builder removed, new one stays)
        if (type.indexOf('pencil') > -1 || type.indexOf('design_complete') > -1) {
          fireBoth('builder_completed', 'Lead', {
            content_category: 'ring-builder',
            value: 0,
            currency: 'AUD'
          });
        }
      }
    });
  }

  // 5. Consultation CTA clicks
  function bindConsultClicks() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest('a');
      if (!el) return;
      var href = el.getAttribute('href') || '';
      if (href.indexOf('showroom-appointment-direct-link') > -1 ||
          href.indexOf('calendly.com') > -1 ||
          href.indexOf('book') > -1 && href.indexOf('appointment') > -1) {
        fireBoth('consult_clicked', 'Schedule', {
          content_category: 'consult',
          link_url: href
        });
      }
    });
  }

  // 6. Online chat tracking (Shopify Inbox / general chat widgets)
  // We track two events:
  //   - chat_opened: user clicks the chat launcher OR a "Start a chat" CTA (intent signal)
  //   - chat_started: user actually sends a first message via postMessage signal
  function bindChatOpens() {
    var chatOpenedFired = false;
    var chatStartedFired = false;

    function fireChatOpened(source) {
      if (chatOpenedFired) return;
      chatOpenedFired = true;
      fireBoth('chat_opened', 'Contact', {
        content_category: 'chat',
        content_name: source || 'shopify-inbox'
      });
    }

    // Helper: check if text content suggests a chat CTA
    function isChatText(txt) {
      if (!txt) return false;
      txt = String(txt).trim().toLowerCase();
      // Bound length to avoid matching long copy that contains the word "chat" incidentally
      if (txt.length < 1 || txt.length > 40) return false;
      return (
        txt === 'chat' ||
        txt === 'live chat' ||
        txt.indexOf('start a chat') > -1 ||
        txt.indexOf('start chat') > -1 ||
        txt.indexOf('chat with us') > -1 ||
        txt.indexOf('chat now') > -1 ||
        txt.indexOf('open chat') > -1 ||
        txt.indexOf('message us') > -1 ||
        txt.indexOf('chat to us') > -1 ||
        txt.indexOf('talk to us') > -1 ||
        txt.indexOf('contact us via chat') > -1
      );
    }

    document.addEventListener('click', function (e) {
      var el = e.target;
      if (!el || !el.closest) return;

      // Strategy 1: structural selectors (Shopify Inbox + generic chat widgets)
      var chatLauncher = el.closest(
        '[id*="ShopifyChat" i],' +
        '[class*="shopify-chat" i],' +
        '[class*="ShopifyChat" i],' +
        '[data-shopify-chat],' +
        '#inbox-launcher,' +
        '.inbox-button,' +
        'shopify-chat-bubble,' +
        'shopify-chat,' +
        'iframe[src*="shopify-inbox"],' +
        'iframe[src*="shopifyinbox"],' +
        'iframe[src*="chat.shopify"],' +
        '[aria-label*="chat" i],' +
        '[aria-label*="message us" i],' +
        '[aria-label*="open chat" i]'
      );

      if (chatLauncher) {
        fireChatOpened('shopify-inbox');
        return;
      }

      // Strategy 2: text-content matching for theme-rendered chat CTAs
      // (e.g. "Start a chat" buttons that don't have aria-label or chat-related class)
      var clickable = el.closest('button, a, [role="button"], [onclick]');
      if (clickable) {
        // Only check direct text, not deeply nested text from huge containers
        var textNodes = clickable.childNodes;
        var directText = clickable.textContent || '';
        if (isChatText(directText)) {
          fireChatOpened('cta-button');
          return;
        }
        // Also check aria-label fallback
        var aria = clickable.getAttribute('aria-label') || '';
        if (isChatText(aria)) {
          fireChatOpened('cta-button');
          return;
        }
      }
    });

    // Listen for postMessage from chat iframes (Shopify Inbox + most third-party widgets
    // post events for state changes — we look for keywords in the type/event/name field)
    window.addEventListener('message', function (event) {
      if (!event || !event.data) return;
      var data = event.data;
      var type = (typeof data === 'string') ? data : (data.type || data.event || data.name || data.action || '');

      if (typeof type !== 'string') return;
      var t = type.toLowerCase();

      // Chat opened (widget expanded)
      if (!chatOpenedFired && (t.indexOf('chat_open') > -1 || t.indexOf('inbox:open') > -1 || t.indexOf('widget_opened') > -1 || t.indexOf('chat:open') > -1 || t.indexOf('shopifyinbox:open') > -1)) {
        fireChatOpened('iframe-postmessage');
      }

      // Chat message actually sent — this is the real lead signal
      if (!chatStartedFired && (t.indexOf('message_sent') > -1 || t.indexOf('chat_message') > -1 || t.indexOf('inbox:message') > -1 || t.indexOf('chat_started') > -1 || t.indexOf('chat:message') > -1 || t.indexOf('shopifyinbox:message') > -1)) {
        chatStartedFired = true;
        fireBoth('chat_started', 'Lead', {
          content_category: 'chat',
          content_name: 'shopify-inbox',
          value: 0,
          currency: 'AUD'
        });
      }
    });

    // Strategy 3: passive observer — detect when a Shopify Inbox iframe gets injected
    // (this fires chat_opened the first time the chat widget appears visible)
    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(function (mutations) {
        if (chatOpenedFired) return;
        mutations.forEach(function (m) {
          for (var i = 0; i < m.addedNodes.length; i++) {
            var node = m.addedNodes[i];
            if (!node || node.nodeType !== 1) continue;
            // Check for chat-related iframes appearing
            var iframe = node.tagName === 'IFRAME' ? node : (node.querySelector ? node.querySelector('iframe[src*="shopify-inbox" i], iframe[src*="shopifyinbox" i], iframe[src*="chat.shopify" i]') : null);
            if (iframe) {
              // Iframe injection alone isn't a chat-open click; only consider it intent if iframe is visible
              if (iframe.offsetWidth > 0 && iframe.offsetHeight > 0) {
                fireChatOpened('iframe-injected');
              }
            }
          }
        });
      });
      observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
